import { render, staticRenderFns } from "./CourtStamp.vue?vue&type=template&id=c2e7e348"
import script from "./CourtStamp.vue?vue&type=script&lang=ts"
export * from "./CourtStamp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports